import { Selectable } from "../models";

/**
 * Converts any entity T into a T & Selectable entity. Use this method
 * where an entity requires an isSelected property which is not defined
 * on the entity.
 * @param item An item onto which an isSelected property will be added.
 * @returns A T & Selectable entity.
 */
export function makeSelectable<T>(item: T): T & Selectable {
  const newItem: T & Selectable = {
    ...item,
    isSelected: false,
  };
  return newItem;
}

/**
 * Converts an array of entities T into an array of T & Selectable entities.
 * Use this method where an array of entities requiring an isSelected property
 * is required but the isSelected property is not defined on the entity.
 * @param arr An array of entities T onto which an isSelected property will be added.
 * @returns An array of T & Selectable entities.
 */
export function makeSelectableArray<T>(arr: T[]): (T & Selectable)[] {
  return arr.map((v) => makeSelectable(v));
}
